import styles from './Llegenda.module.scss'
export default function EclipseLlegenda({ texts }) {
	return (
		<div className={styles.container}>
			<p>
				<span className={styles.punts} /> {texts.officialPoints} [
				<a href='https://eclipsicatalunya.cat/punts-d-observacio/' target='_blank' rel='noopener noreferrer'>
					{texts.moreInfo}
				</a>
				]
			</p>
			<p>
				<span className={styles.franja} /> {texts.totalityBand}
			</p>
			<p>
				{texts.source}{' '}
				<a href='https://visualizadores.ign.es/eclipses/2026' target='_blank' rel='noopener noreferrer'>
					CNIG/IGN
				</a>
			</p>
			<p>{texts.visibilityNote}</p>
		</div>
	)
}
